import { useQuery, useQueryClient } from '@tanstack/react-query'
import { NotebookTabs } from 'lucide-react'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import { publicApi } from '@/lib/api'
import { getAdminSession } from '@/lib/adminSession'
import { getSiteListingCopy } from '@/lib/siteListingMode'
import { getFallbackSiteSettings } from '@/lib/siteSettingsCache'

const siteLogoUrl = '/favicon.svg'

export function HomePage() {
  const queryClient = useQueryClient()
  const siteSettingsQuery = useQuery({
    queryKey: ['public-site-settings'],
    queryFn: publicApi.getSiteSettings,
    initialData: getFallbackSiteSettings(),
  })

  const siteSettings = siteSettingsQuery.data ?? getFallbackSiteSettings()
  const adminSession = getAdminSession()
  const listingCopy = getSiteListingCopy(siteSettings.listingMode)

  useEffect(() => {
    void queryClient.prefetchQuery({
      queryKey: ['public-products'],
      queryFn: publicApi.listProducts,
      staleTime: 30_000,
    })
  }, [queryClient])

  return (
    <div className="page-stack page-stack--home">
      <section className={`landing-split ${siteSettings.homeFullBleed ? 'landing-split--full' : ''}`}>
        <div className="landing-split__media">
          {siteSettings.homeHeroImageUrl ? (
            <img alt={siteSettings.brandName} className="landing-hero__image" draggable={false} src={siteSettings.homeHeroImageUrl} />
          ) : (
            <div className="landing-hero__placeholder">
              <div className="landing-hero__placeholder-mark">
                <img alt="" className="brand__logo" draggable={false} src={siteLogoUrl} />
                <strong>{siteSettings.brandName}</strong>
              </div>
              <span>展示内容、记录赞助、自动发放</span>
            </div>
          )}
        </div>

        <div className="landing-split__content">
          <div className="landing-split__content-inner">
            <div className="landing-hero__brand">
              <img alt={siteSettings.brandName} className="brand__logo landing-hero__brand-logo" draggable={false} src={siteLogoUrl} />
            </div>
            <h1>欢迎来到 {siteSettings.brandName}</h1>
            <p className="landing-hero__lead">{siteSettings.siteDescription}</p>
            <div className="landing-notice-panel">
              <div className="landing-hero__announcement-head">
                <NotebookTabs size={18} />
                <strong>站点公告</strong>
              </div>
              <p>{siteSettings.homeAnnouncement}</p>
            </div>
            <div className={`landing-hero__actions ${adminSession ? 'has-admin' : ''}`}>
              <Link className="landing-action landing-action--primary" to="/products">
                {listingCopy.homePrimaryLabel}
              </Link>
              <Link className="landing-action landing-action--secondary" to="/orders/query">
                记录查询
              </Link>
              {adminSession ? (
                <Link className="landing-action landing-action--admin" to="/admin">
                  管理后台
                </Link>
              ) : null}
            </div>
          </div>
          <footer className="landing-split__footer">
            <span>&copy; {siteSettings.footerYear} {siteSettings.brandName}. All rights reserved.</span>
            {siteSettings.beianNo ? (
              <a className="site-footer__beian" href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">
                {siteSettings.beianNo}
              </a>
            ) : null}
          </footer>
        </div>
      </section>
    </div>
  )
}
